import { Steps as AntdSteps } from 'antd';
import StyledSteps from './styles/steps.style';

const Steps = StyledSteps(AntdSteps);

export default Steps;